import React, { useEffect, useReducer, useState } from 'react'

import { Dialog, DialogTrigger } from '@/Components/ui/dialog'
import { Button } from '@/Components/ui/button'

import Datatable from '@/Components/Common/Datatable'
import { Input } from '@/Components/ui/input'
import { useLocation, useNavigate } from 'react-router-dom'

import { useDebounce } from 'use-debounce'
import Constant from '@/utils/Constant'
import HeaderCard from '@/Components/HeaderCard'
import BodyCard from '@/Components/BodyCard'
import { SquarePlus } from 'lucide-react'
import DataTableEnumType from '@/Enums/DataTableTypeEnum'
import { useAuth } from '@/Context/AuthContext'
import RequiredPermission from '@/assets/data/RequiredPermission'
import { checkPermission } from '@/utils/helper'
import DeleteConfirmationTypeEnum from '@/Enums/DeleteConfirmationTypeEnum'
import ConfirmationPopup from '@/Components/Common/ConfirmationPopup'
import ClientService from '@/Service/ClientService'
import ActivityLogColumn from './ActivityLogColumns'
import ActivityLogService from '@/Service/ActivityLogService'

const ActivityLogListing = () => {
    const { userInfo } = useAuth()
    const navigate = useNavigate()

    const [event, updateEvent] = useReducer((prev, next) => ({ ...prev, ...next }), {
        totalActivityLogCount: 0,
        isDataFetching: false,
        activityLog: [],
        searchActivityLogId: '',
        searchMRNumber: '',
        queryParam: {
            page: 1,
            id: '',
            mr_number: '',
        },
    })
    const [debouncedActivityLogSearch] = useDebounce(event.searchActivityLogId, Constant.DEBOUNCE_DELAY)
    const [debouncedSearchMRNumber] = useDebounce(event.searchMRNumber, Constant.DEBOUNCE_DELAY)
    const location = useLocation()
    const getActivityLog = async () => {
        updateEvent({ isDataFetching: true, activityLog: [] })
        try {
            const resp = await ActivityLogService.getActivityLogs(event.queryParam)
            if (resp.data.success) {
                updateEvent({ activityLog: resp.data.data, totalActivityLogCount: resp.data.pagination.total_record })
            }
        } catch (err) {}
        updateEvent({ isDataFetching: false })
    }
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search)
        const page = parseInt(searchParams.get('page') || 1)
        updateEvent({
            queryParam: {
                ...event.queryParam,
                page,
            },
        })
    }, [location.search])

    useEffect(() => {
        getActivityLog()
    }, [event.queryParam.page, event.queryParam.id, event.queryParam.mr_number])

    useEffect(() => {
        updateEvent({
            queryParam: {
                ...event.queryParam,
                id: debouncedActivityLogSearch,
                mr_number: debouncedSearchMRNumber,
            },
        })
    }, [debouncedActivityLogSearch, debouncedSearchMRNumber])

    return (
        <div>
            <HeaderCard></HeaderCard>
            <BodyCard>
                <div className="w-full my-2 grid grid-cols-4 gap-3">
                    <Input
                        type="text"
                        value={event.searchActivityLogId}
                        onChange={(e) => updateEvent({ searchActivityLogId: e.target.value })}
                        placeholder="ID"
                    />
                    <Input
                        type="text"
                        value={event.searchMRNumber}
                        onChange={(e) => updateEvent({ searchMRNumber: e.target.value })}
                        placeholder="MR Number"
                    />
                </div>
                <Datatable
                    columns={ActivityLogColumn()}
                    data={event.activityLog}
                    totalDataCount={event.totalActivityLogCount}
                    allcheck={false}
                    deleteId={[]}
                    updateEvent={() => null}
                    loading={event.isDataFetching}
                    type={DataTableEnumType.ACTIVITY_LOG}
                />
            </BodyCard>
        </div>
    )
}

export default ActivityLogListing
